module.exports = __webpack_public_path__ + "files/849c85e3e60cb9d967e03345f5f5023b.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-17.png
// module id = 1506
// module chunks = 60